import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Langs from "../../../app/lang/langs";
import styles from '../VcompCompnents.module.css';
import ImageButton from "../../buttons/ImageButton";
import nextTab from "../../../assets/images/nextTab.png";
import prevTab from "../../../assets/images/prevTab.png";
import nextTabFocus from "../../../assets/images/nextTabFocus.png";
import prevTabFocus from "../../../assets/images/prevTabFoxus.png";

/**
 * NavigationMenu - Renders the left sidebar menu (desktop) and the
 * mobile tab bar for navigating between project creation steps.
 *
 * @param {object} props
 * @param {number} props.activeIndex - Currently active tab index
 * @param {function} props.setActiveIndex - Setter for active tab index
 * @param {number} props.isMobile - 1 = desktop, 2 = mobile, 3 = tablet
 * @param {string} props.mode - 'edit' or null
 * @param {boolean} props.isInDatabase - Whether the project has been saved to DB
 * @param {string} props.projectName - Current project name (for determining clickability)
 * @param {function} props.onConfirmClose - Handler for confirm close (back arrow on details tab)
 * @param {function} props.onSaveDetails - Handler for saving project details (forward arrow on details tab)
 */
export default function NavigationMenu({
    activeIndex,
    setActiveIndex,
    isMobile,
    mode,
    isInDatabase,
    projectName,
    onConfirmClose,
    onSaveDetails,
}) {
    const isClickable = projectName != "";

    if (isMobile !== 1) {
        // Mobile / Tablet tab bar
        const onTabChange = (_event, newValue) => {
            setActiveIndex(newValue);
        };
        return (
            <div style={{ borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
                <Tabs
                    value={activeIndex}
                    onChange={onTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{
                        '& .MuiTab-root': {
                            textTransform: 'none',
                            fontWeight: 500,
                            fontSize: '0.875rem',
                        },
                        '& .MuiTabs-indicator': {
                            backgroundColor: 'rgb(255, 144, 21)',
                        },
                        '& .Mui-selected': {
                            color: 'rgb(255, 144, 21) !important',
                        },
                    }}
                >
                    <Tab label="General" />
                    <Tab label={<Langs str="PUBLIC_FORMULAIRE" />} disabled={!isInDatabase} />
                    <Tab label={<Langs str="EDIT_FORM" />} disabled={!isInDatabase} />
                    <Tab label={<Langs str="MEMBERS" />} disabled={!isInDatabase} />
                    <Tab label={<Langs str="MANAGERS" />} disabled={!isInDatabase} />
                    <Tab label={<Langs str="PROGRESS" />} disabled={!isInDatabase} />
                </Tabs>
            </div>
        );
    }

    // Desktop left menu
    return (
        <ul className={styles.menuLeft}>
            {mode === 'edit' &&
                <li
                    onClick={() => isClickable && isInDatabase && setActiveIndex(6)}
                    className={`${activeIndex === 6 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
                >
                    <Langs str="PROGRESS" />
                </li>
            }
            <li
                onClick={() => isClickable && setActiveIndex(0)}
                className={`${activeIndex === 0 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                {isMobile === 2 &&
                    <ImageButton
                        onClick={() => isClickable && onConfirmClose()}
                        image={prevTab}
                        imageFocus={prevTabFocus}
                        active={isClickable}
                        width={22} />}
                <span className="mx-4"><Langs str="PROJECT_DETAILS" /></span>
                {isMobile === 2 && <ImageButton
                    onClick={() => isClickable && onSaveDetails()}
                    image={nextTab}
                    imageFocus={nextTabFocus}
                    active={isClickable}
                    width={22} />}
            </li>
            <li
                onClick={() => isClickable && setActiveIndex(1)}
                className={`${activeIndex === 1 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                <Langs str="PUBLIC_FORMULAIRE" />
            </li>
            <li
                onClick={() => isClickable && isInDatabase && setActiveIndex(2)}
                className={`${activeIndex === 2 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                <Langs str="PROJECT_QUESTIONS_BANK" />
            </li>
            <li
                onClick={() => isClickable && setActiveIndex(3)}
                className={`${activeIndex === 3 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                <Langs str="EDIT_FORM" /> & <Langs str="MCQ" />
            </li>
            <li
                onClick={() => isClickable && isInDatabase && setActiveIndex(4)}
                className={`${activeIndex === 4 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                <Langs str="MEMBERS" /> & <Langs str="MCQ" />
            </li>
            <li
                onClick={() => isClickable && isInDatabase && setActiveIndex(5)}
                className={`${activeIndex === 5 ? styles.selected : ''} ${!isClickable ? styles.disabled : ''}`}
            >
                <Langs str="MANAGERS" />
            </li>
        </ul>
    );
}
